import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import {
  VersionMantenimientoBody,
  VersionMantenimientoContainer,
  VersionMantenimientoHeader,
} from "./localStyle";
const VersionMantenimiento = () => {
  const { versionPublicadaState } = useContext(GlobalContext);
  return (
    <VersionMantenimientoContainer>
      <VersionMantenimientoHeader>
        <span className="rb16b c-white">Atención</span>
      </VersionMantenimientoHeader>
      <VersionMantenimientoBody>
        <span className="rb16b">
          {versionPublicadaState.versionPublicada.data.msjMantenimiento}
        </span>
      </VersionMantenimientoBody>
    </VersionMantenimientoContainer>
  );
};

export default VersionMantenimiento;
